import Common from '../../Common';
import { TemplateType } from '../../Enums';

const Template = class extends Common {
	browse(userId?: id, templateType?: TemplateType) {
		let url = '/user';

		if (userId) {
			url += `/${userId}`
		}

		url += '/template';

		if (templateType) {
			url += `/${templateType}`
		}

		return this.get(url);
	}
}

export default Template;
